import React from 'react';
import {connect} from 'react-redux';
import * as actions from '../../Combo/comboActions';
import ComboSummary from './ComboSummary';
import {removeComboFromCart} from '../../Cart/cartActions';

const ComboSummaryContainer = ({
  combo,
  comboIndex,
  editComboInCart,
  removeComboFromCart,
  validatedCart,
}) => {
  const editCombo = () => {
    editComboInCart(combo, comboIndex);
  };

  const removeCombo = () => {
    removeComboFromCart(comboIndex);
  };

  return (
    <ComboSummary
      combo={combo}
      editCombo={editCombo}
      removeCombo={removeCombo}
      validatedCart={validatedCart}
    />
  );
};

const mapStateToProps = state => ({
  validatedCart: state.cartReducer.validatedCart,
});

export default connect(mapStateToProps, {
  ...actions,
  removeComboFromCart,
})(ComboSummaryContainer);
